import Linkedme from './Linkedme';

export default new Linkedme(process.env.VUE_APP_LINKEDME);
